export default __webpack_public_path__ + "static/media/fashionnova-logo.edd30b6a.png";